import React, { useEffect } from "react";
import educationImage from "../../../assets/images/education.png";
import { useSelector, useDispatch } from "react-redux";
import { getEducations } from "../../../actions/educationAction";
import moment from "moment";
import { useTranslation } from "react-i18next";
import NeonHeading from "../NeonHeading/NeonHeading";


const Education = ({ reff }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const educations = useSelector((state) => state.educations);

  useEffect(() => {
    dispatch(getEducations());
  }, [dispatch]);

  const education = educations.map((edu) => {
    return (
      <div key={edu._id} className="col-xl-10 col-md-11 col-10 mx-5">
        <p className="fw-bold mb-3" style={{ fontSize: "19px" }}>
          {t(edu.title)} {/* t() fonksiyonu eklendi */}
        </p>
        <p className="mb-3 text-primary" style={{ fontSize: "14px" }}>
          {t(edu.school)}, {t(edu.city)} {/* t() fonksiyonu eklendi */}
        </p>
        <p className="grey-text" style={{ fontSize: "13px" }}>
          {moment(edu.startDate).format("MMM YYYY")} -{" "}
          {moment(edu.endDate).format("MMM YYYY")}
        </p>
        <hr className="mb-4" />
      </div>
    );
  });

  return (
    <section
      ref={reff}
      id="education"
      className="py-5"
      style={{ backgroundColor: "#fff" }}
    >
      <div className="container">
        <NeonHeading color="blue">
          {t('fo12.24')}
        </NeonHeading>

        <div className="row">
          <div className="col-lg-5 col-md-12 text-center text-lg-left">
            <img
              className="img-fluid mb-3 d-none d-lg-inline"
              src={educationImage}
              alt="education"
            />
          </div>

          <div className="col-lg-7">
            <div className="row mb-3">{education}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
